import { render, staticRenderFns } from "./credit-type-admin.vue?vue&type=template&id=ba03f8d6"
import script from "./credit-type-admin.vue?vue&type=script&lang=js"
export * from "./credit-type-admin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba03f8d6')) {
      api.createRecord('ba03f8d6', component.options)
    } else {
      api.reload('ba03f8d6', component.options)
    }
    module.hot.accept("./credit-type-admin.vue?vue&type=template&id=ba03f8d6", function () {
      api.rerender('ba03f8d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/credit-type-admin.vue"
export default component.exports